/**
 * @generated SignedSource<<5b6941a7e42944b59d2871dbf15a4b26>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type SingleUnitTargetStudentIsWorkingOnQuery$variables = {
  userId: string;
};
export type SingleUnitTargetStudentIsWorkingOnQuery$data = {
  readonly getTargetStudentIsWorkingOn: {
    readonly id: string;
    readonly name: string | null | undefined;
    readonly summary: string | null | undefined;
  } | null | undefined;
};
export type SingleUnitTargetStudentIsWorkingOnQuery = {
  response: SingleUnitTargetStudentIsWorkingOnQuery$data;
  variables: SingleUnitTargetStudentIsWorkingOnQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "userId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "userId",
        "variableName": "userId"
      }
    ],
    "concreteType": "TargetNode",
    "kind": "LinkedField",
    "name": "getTargetStudentIsWorkingOn",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "summary",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SingleUnitTargetStudentIsWorkingOnQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SingleUnitTargetStudentIsWorkingOnQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "092f3bfdc1a796d33b95baa8d54e1d08",
    "id": null,
    "metadata": {},
    "name": "SingleUnitTargetStudentIsWorkingOnQuery",
    "operationKind": "query",
    "text": "query SingleUnitTargetStudentIsWorkingOnQuery(\n  $userId: ID!\n) {\n  getTargetStudentIsWorkingOn(userId: $userId) {\n    id\n    name\n    summary\n  }\n}\n"
  }
};
})();

(node as any).hash = "a9bf8e6e7afa38cb272ee931808538f6";

export default node;
